import { render, staticRenderFns } from "./DemandaPainelDataTable.vue?vue&type=template&id=1702035f&scoped=true&"
import script from "./DemandaPainelDataTable.vue?vue&type=script&lang=js&"
export * from "./DemandaPainelDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DemandaPainelDataTable.vue?vue&type=style&index=0&id=1702035f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1702035f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VPagination,VProgressLinear,VRow})
